<template>
  <div class="home_box">
    <div class="home_bg">
      <!-- <div class="bg_content">
        <div class="head_title">酒店新型储能解决方案</div>
        <div class="content_text">
          储能+节能，为酒店开启智慧能源新时代
        </div>
        <div class="slogan_box">
          <div>储能：削峰填谷、智控电价</div>
          <div>节能：数字管理、精降能耗</div>
        </div>
        <div class="green_code_nav">
          <img class="img_code" src="../assets/img/imageNew/greenEnergy/text.png" alt="">
        </div>
      </div> -->
    </div>
    <div class="new_box xxcn">
      <div class="new_title">
        <!-- <span>新型储能</span> -->
        <img src="https://sys.huwei.xin:7443/huwei-website/imageNew/index/title1.png" alt="">
      </div>
      <!-- <div class="new_slogan">
        酒店降本增效的绿色引擎
      </div> -->
      <div class="new_content">
        互为酒店新型储能解决方案，采用“储能+节能”相结合的模式。
        <br />
        <br />
        “储能”通过削峰填谷，降低用电价格；“节能”通过专业的能<br />源数字化管理平台（绿能专家），辅助酒店运营管理，降低用电<br />能耗。
      </div>
      <img src="https://sys.huwei.xin:7443/huwei-website/imageNew/index/weitu.png" alt="" class="weitu">
    </div>
    <div class="index_icons">
      <!-- <div class="icon_li">
        <img src="../assets/img/imageNew/index/i1.png" alt="">
        <span>精准分析</span>
        <div class="bian"></div>
      </div>
      <div class="icon_li">
        <img src="../assets/img/imageNew/index/i2.png" alt="">
        <span>经验赋能</span>
        <div class="bian"></div>
      </div>
      <div class="icon_li">
        <img src="../assets/img/imageNew/index/i3.png" alt="">
        <span>优化配置</span>
        <div class="bian"></div>
      </div>
      <div class="icon_li">
        <img src="../assets/img/imageNew/index/i4.png" alt="">
        <span>全程托管</span>
        <div class="bian"></div>
      </div>
      <div class="icon_li">
        <img src="../assets/img/imageNew/index/i5.png" alt="">
        <span>快速落地</span>
        <div class="bian"></div>
      </div>
      <div class="icon_li">
        <img src="../assets/img/imageNew/index/i6.png" alt="">
        <span>稳定可靠</span>
      </div> -->
    </div>
    <!-- 绿能专家 -->
    <div class="new_box lvzj">
      <div class="new_title">
        <!-- <span>绿能专家</span> -->
        <img src="https://sys.huwei.xin:7443/huwei-website/imageNew/index/title2.png" alt="">
      </div>
      <!-- <div class="new_slogan">
        基于能源物联网的酒店绿能管理专家
      </div> -->
      <div class="menu">
        <div class="item" v-for="item in menuList" :key="item.icon">
          <div class="item_title">
            <div class="label">{{ item.label }}
              <div class="heng"></div>
              <div class="heng2"></div>
            </div>
            <img :src="('https://sys.huwei.xin:7443/huwei-website/icon/' + item.icon)" alt="">
          </div>
          <div class="description">{{ item.description }}</div>
        </div>
      </div>
    </div>
    <div class="public_benefit_column_nav">
      <div class="content_nav">
        <div class="description_text">
          <div style="display: flex; align-items: baseline;">
            <div class="title">硬件设备</div>
            <div class="en_title">Hardware Equipment</div>
          </div>
        </div>
        <div class="menu">
          <div class="item_boxs" v-for="(item, index) in equipmentList" :key="item.index" >
            <div class="heng"></div>
            <div class="heng1"></div>
            <div class="img_box" :style="index<2?'bottom: -7px;': ''">
              <img :src="item.img" :alt="item.label">
            </div>
            <div class="item">
              <div class="label_box">
                <div class="label">{{ item.label }}</div>
                <div class="en_label">{{ item.en_label }}</div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
    <div class="characteristic_description_nav">
      <div class="menu" v-for="(item,index) in characteristicList" :key="item.description">
        <img :src="item.icon" alt="">
        <div class="label">{{ item.label }}</div>
        <div class="description">{{ item.description }}</div>
      </div>
    </div>
    <div class="new_box lvnp">
      <div class="new_title">
        <!-- <span>绿能派</span> -->
        <img src="https://sys.huwei.xin:7443/huwei-website/imageNew/index/title3.png" alt="">
      </div>
      <!-- <div class="new_slogan">
        致力于公益的节能大使
      </div> -->
      <div class="new_content">
        “绿能派”由杭州互为综合能源服务有限公司创建，始终秉承“源于社会，回馈社会”的社会责任理念，大力倡导和发展绿色低碳事业，积极发起并参与教育、环保、慈善等社会公益项目。
      </div>
    </div>

    <!-- 绿能派 nav -->
    <div class="green_energy_nav">
      <div class="public_benefit_column">
        <div class="function_box" style="display: flex; align-items: baseline;">
          <div class="label">微公益</div>
          <div class="en_label">Micro public welfare</div>
        </div>
        <div class="content_nav">
          <div class="description_text">
            
            <div class="public_benefit_content">
              <div class="address">安民乡中心小学</div>
              <div class="coord">
                <img src="../assets/img/address_icon.png" alt="">
                丽水市松阳县安民乡大潘坑村
              </div>
              <div class="address_introduce">
                安民乡中心小学位于松阳县西南山区，
                交通不便，气候高寒。当地主要以农业收入为主，收入单一，
                学生家庭大多条件艰苦，父母双方外出打工的家庭很多。<br/><br/>
                据校长陈梦倩介绍，全校有六个年级一个幼儿班共46名学生，
                13名教师，由于交通不便，学生和老师都是一周只回家一次。
              </div>
            </div>
          </div>
          <div class="swipper_box">
            <el-carousel :autoplay="false" @change="change" ref="carusel" arrow="never" :loop="false" :interval="4000" indicator-position="none" type="card" height="420px">
              <el-carousel-item v-for="item in swipperList" :ref="'index'+item.index" :class="currentPage+1== item.index? 'next' : ''" :key="item">
                <img class="swipper_img" :src="('https://sys.huwei.xin:7443/huwei-website/swipper/' + item.img)" alt="">
              </el-carousel-item>
            </el-carousel>
            <div class="button_nav">
              <img class="left_icon" v-if="currentPage == 1" src="https://sys.huwei.xin:7443/huwei-website/swipper/left_icon.png">
              <img class="left_icon2" v-if="currentPage > 1" @click="_last()" src="https://sys.huwei.xin:7443/huwei-website/swipper/right_icon.png">
              <span class="page_text">
                <span class="current_page">{{ '0'+currentPage }}</span>
                <span class="next_page"> / 05</span>
              </span>
              <img class="right_icon" v-if="currentPage < 5" @click="_next()" src="https://sys.huwei.xin:7443/huwei-website/swipper/right_icon.png">
              <img class="right_icon2" v-if="currentPage >= 5" src="https://sys.huwei.xin:7443/huwei-website/swipper/left_icon.png">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="new_box zlzs">
      <!-- <div class="new_title">
        <span>专利证书</span>
        <img src="../assets/img/imageNew/index/闪电.png" alt="">
      </div>
      <div class="new_slogan">
        为了环保我们需要更加努力
      </div> -->
    </div>
    <div class="new_box hzjd">
      <div class="new_title">
        <!-- <span>部分合作酒店</span> -->
        <img src="https://sys.huwei.xin:7443/huwei-website/imageNew/index/title4.png" alt="">
      </div>
      <!-- <div class="new_slogan">
        共筑绿色旅居生活
      </div> -->
      <div class="cooperation_content">
        <div class="cooperation_box">
          <div class="button">
            <el-icon class="icon" @click="goLeft()"><ArrowLeftBold /></el-icon>
            <el-icon class="icon" @click="goRight()"><ArrowRightBold /></el-icon>
          </div>
          <div class="menu">
            <!-- <template  v-for="aa in 6"> -->
              <div class="item_box" v-for="item in hotelListPage[hotelIndex]" :key="item.name">
                <img class="img" :src="item.img" :alt="item.name">
                <div class="hotel_info">
                  <div class="hotel_name">{{ item.name }}</div>
                  <div class="address">{{ item.address }}</div>
                </div>
              </div>
            <!-- </template> -->
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { computed, ref, getCurrentInstance   } from "vue";
import { ArrowLeftBold, ArrowRightBold } from '@element-plus/icons'
export default {
  name: "Home",
  components: {
    ArrowLeftBold, ArrowRightBold
  },
  setup() {
    const state = computed(() => useStore().state.client);
    const swipperList = ref([
      {
        index: 1,
        img: '01.jpg'
      },
      {
        index: 2,
        img: '02.jpg'
      },
      {
        index: 3,
        img: '03.jpg'
      },
      {
        index: 4,
        img: '04.jpg'
      },
      {
        index: 5,
        img: '05.jpg'
      },
    ])
    const hotelIndex = ref(0)
    const goRight = () => {
      if(hotelIndex.value == hotelListPage.value.length - 1) {
        hotelIndex.value = 0;
      }else {
        hotelIndex.value ++;
      }
    }
    const goLeft = () => {
      if(hotelIndex.value == 0) {
        hotelIndex.value = hotelListPage.value.length - 1;
      }else {
        hotelIndex.value --;
      }
    }
    const menuList = ref([
      {
        icon: 'data_icon.png',
        label: '数据物联',
        description: '建立电量采集分析系统，用电信息上传至云服务中心，并建立相应接口，实现对用电信息的连续监测。'
      },
      {
        icon: 'cloud_service_icon.png',
        label: '云端服务',
        description: '基于日益增长的互联网服务需求，融合线上线下交互模式，确保服务安全稳定。'
      },
      {
        icon: 'analysis_icon.png',
        label: '高级分析',
        description: '实现客户用电行为分析、酒店飞单研判、单会员优惠幅度建议、酒店内部线路改造建议等高级分析。'
      },
      {
        icon: 'calculate_icon.png',
        label: '精细计算',
        description: '在配电间、电梯间、设备间等关键供电部位安装电能计量装置，实现客房、电梯、热水设备、公共区域用电精细化计量。'
      },
      {
        icon: 'energy_icon.png',
        label: '能耗分析',
        description: '实现用电实时监测、用电负荷分析、用电日月年分析，以及用电过程中的异常报警、安全隐患告警。'
      },
      {
        icon: 'electric_icon.png',
        label: '电量预测',
        description: '建立一套科学完善的电能预测、计划和评估体系，为采购电量预判、用量总量监测等提供数据基础。'
      },
    ])
    const equipmentList = ref([
      {
        index: '01',
        img: `https://sys.huwei.xin:7443/huwei-website/imageNew/index/yj01.png`,
        label: '采集器终端',
        en_label: 'Collector terminal'
      },
      {
        index: '02',
        img: `https://sys.huwei.xin:7443/huwei-website/imageNew/index/yj02.png`,
        label: '数据管理终端',
        en_label: 'Data management terminal'
      },
      {
        index: '03',
        img: `https://sys.huwei.xin:7443/huwei-website/imageNew/index/yj03.png`,
        label: '烟雾报警器',
        en_label: 'Smoke detector'
      },
      {
        index: '04',
        img: `https://sys.huwei.xin:7443/huwei-website/imageNew/index/yj04.png`,
        label: '闭口互感器',
        en_label: 'Closed transformerl'
      },
      {
        index: '05',
        img: `https://sys.huwei.xin:7443/huwei-website/imageNew/index/yj05.png`,
        label: '开口互感器',
        en_label: 'Open transformer'
      },
      {
        index: '06',
        img: `https://sys.huwei.xin:7443/huwei-website/imageNew/index/yj06.png`,
        label: '温度传感器',
        en_label: 'Temperature sensor'
      }
    ])
    const characteristicList = ref([
      {
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/index/num_bg1.png`,
        label: '传感器重用',
        description: '采用共用电压互感器、独立电流互感器的方式，通过软件实现电压与电流测量数据的匹配，减少装置数量，降低成本。'
      },
      {
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/index/num_bg2.png`,
        label: '免改线安装',
        description: '间接式接入方法与自身设备相结合，避免了大量电力线路的投入，减少辅材投入，加快施工周期，缩短停电时间。'
      },
      {
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/index/num_bg3.png`,
        label: '降低通讯成本',
        description: '能耗监测装置具备独立4G无线通信功能，可直接将数据上传至云服务中心，无需增加任何网络建设成本。'
      },
      {
        icon: `https://sys.huwei.xin:7443/huwei-website/imageNew/index/num_bg4.png`,
        label: '数据存储备份',
        description: '能耗采集装置和数据集中器装配大容量存储芯片，在通信故障情况下可保存数据15天不丢失，系统或网络恢复后自动将遗漏数据补报'
      },
    ])
    const hotelListPage = ref([
      [{
        name: '杭州龙禧福朋喜来登酒店',
        img: `https://sys.huwei.xin:7443/huwei-website/imageNew/index/hotel/hotel_1.png`,
        address: '滨江地区 | 东信大道868号'
      },
      {
        name: '海南海花岛欧堡酒店',
        img: `https://sys.huwei.xin:7443/huwei-website/imageNew/index/hotel/hotel_2.jpg`,
        address: '儋州市 | 滨海大道海花岛1号岛'
      },
      {
        name: '合肥两淮豪生大酒店',
        img: `https://sys.huwei.xin:7443/huwei-website/imageNew/index/hotel/hotel_3.jpg`,
        address: '高新技术开发区 | 科学大道6号'
      },],
      [{
        name: '杭州海外海皇冠大酒店',
        img: `https://sys.huwei.xin:7443/huwei-website/imageNew/index/hotel/hotel_4.jpg`,
        address: '武林广场 | 上塘路333号'
      },
      {
        name: '舟山铂尔曼酒店',
        img: `https://sys.huwei.xin:7443/huwei-website/imageNew/index/hotel/hotel_5.jpg`,
        address: '普陀区 | 海洲路711号'
      },
      {
        name: '浙江西湖山庄',
        img: `https://sys.huwei.xin:7443/huwei-website/imageNew/index/hotel/hotel_6.jpg`,
        address: '西湖景区 | 北山路84号'
      },],
      [{
        name: '杭州西湖国宾馆',
        img: `https://sys.huwei.xin:7443/huwei-website/imageNew/index/hotel/hotel_7.jpg`,
        address: '西湖景区 | 杨公堤18号'
      },
      {
        name: '千岛湖温馨岛蝶来度假酒店',
        img: `https://sys.huwei.xin:7443/huwei-website/imageNew/index/hotel/hotel_8.jpg`,
        address: '千岛湖风景区 | 千岛湖温馨岛'
      },
      {
        name: '海南三亚皇冠假日度假酒店',
        img: `https://sys.huwei.xin:7443/huwei-website/imageNew/index/hotel/hotel_9.jpg`,
        address: '天涯区 | 三亚湾路228号'
      },],
      [{
        name: '杭州天目都喜天丽酒店',
        img: `https://sys.huwei.xin:7443/huwei-website/imageNew/index/hotel/hotel_10.jpg`,
        address: '临安区 | 天目山镇天目村新村33号'
      },
      {
        name: '浙江杭州优盘时代商务中心',
        img: `https://sys.huwei.xin:7443/huwei-website/imageNew/index/hotel/hotel_11.png`,
        address: '西湖区 | 萍水西街80号'
      },
      {
        name: '三亚悦澜湾君澜度假酒店',
        img: `https://sys.huwei.xin:7443/huwei-website/imageNew/index/hotel/hotel_12.jpg`,
        address: '吉阳区 | 大茅西路4号'
      },],
      [{
        name: '杭州青山湖美爵酒店',
        img: `https://sys.huwei.xin:7443/huwei-website/imageNew/index/hotel/hotel_13.jpg`,
        address: '临安青山湖 | 科技大道4396号'
      },
      {
        name: '杭州建德雷迪森怿曼酒店',
        img: `https://sys.huwei.xin:7443/huwei-website/imageNew/index/hotel/hotel_14.png`,
        address: '新安江街道 | 新安江街道新电路37号'
      },
      {
        name: '杭州云村黄龙璀丽酒店',
        img: `https://sys.huwei.xin:7443/huwei-website/imageNew/index/hotel/hotel_15.jpg`,
        address: '临安青山湖 | 青山湖街道胜联路328号'
      },],
      [{
        name: '杭州千岛湖中心湖区亚朵酒店',
        img: `https://sys.huwei.xin:7443/huwei-website/imageNew/index/hotel/hotel_16.jpg`,
        address: '千岛湖中心湖区 | 淳安县新安大街11号'
      },]
    ])
    const currentPage = ref(1)
    const dom = getCurrentInstance()
    const change = (e) => {
      currentPage.value = e+1
    }
    const _last = () => {
      dom.refs.carusel.prev()
    }
    const _next = () => {
      dom.refs.carusel.next()
    }
    return {
      state,
      swipperList,
      change,
      currentPage,
      _last,
      _next,
      goRight,
      goLeft,
      hotelIndex,
      menuList,
      equipmentList,
      characteristicList,
      hotelListPage,
    };
  },
};
</script>

<style lang="scss" scoped>
.home_box {
  width: 100%;
  // height: 982px;
  // background: linear-gradient(243deg, #003174 0%, #00224E 100%);
  .home_bg {
    background: url('https://sys.huwei.xin:7443/huwei-website/imageNew/index/index_bg.png') 0 0 no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 857px;
    .bg_content {
      position: relative;
      display: flex;
      flex-direction: column;
      padding: 160px 200px 0;
      box-sizing: border-box;
      .head_title {
        font-size: 60px;
        font-family: AlibabaPuHuiTiH;
        color: #132F59;
        line-height: 58px;
        -webkit-background-clip: text;
        // -webkit-text-fill-color: transparent;
      }
      .content_text {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        padding-top: 25px;
        color: #132F59;
        line-height: 36px;
        -webkit-background-clip: text;
        margin-bottom: 100px;
      }
      .slogan_box{
        div{
          width: 337px;
          height: 72px;
          border-radius: 49px;
          border: 1px dashed #132F59;
          line-height: 72px;
          text-align: center;
          font-size: 24px;
          color: #3D3F55;
          margin-bottom: 30px;
        }
      }
      .green_code_nav {
        display: flex;
        flex-direction: column;
        padding-top: 110px;
        .img_code {
          width: 230px;
        }
        .slogan_text {
          padding-top: 16px;
          font-size: 14px;
          color: #ffffff52;
          line-height: 20px;
        }
      }

    }
  }
  .green_energy_nav {
    .green_energy_box{
      height: 404px;
      padding: 160px 0 62px;
      box-sizing: border-box;
      .description_box {
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
      .description_text {
        font-size: 18px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        width: 1158px;
        font-weight: 500;
        color: #474747;
        line-height: 22px;
        position: relative;
        line-height: 25px;
        padding-top: 20px;
      }
      .app_explain {
        width: 100%;
        background: #ffffff;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 120px;
        .app_explain_bg {
          position: absolute;
          font-size: 150px;
          font-weight: bold;
          color: #FBFBFB;
          line-height: 120px;
        }
        .name {
          font-size: 34px;
          font-family: PingFang-SC-Heavy, PingFang-SC;
          font-weight: 800;
          color: #000013;
          line-height: 42px;
          position: relative;
        }
        .slogan, .description_text {
          font-size: 18px;
          font-family: PingFang-SC-Medium, PingFang-SC;
          width: 1158px;
          font-weight: 500;
          color: #474747;
          line-height: 22px;
          position: relative;
        }
        .slogan {
          padding: 8px 0 18px;
        }
      }
    }
    .public_benefit_column {
      background: url(https://sys.huwei.xin:7443/huwei-website/public_benefit_bg.png) 0 0 no-repeat;
      background-size: 100% 100%;
      padding: 100px 0 100px 200px;
      .function_box {
        display: flex;
        align-items: baseline;
        margin-bottom: 100px;
        .label {
          font-size: 40px;
          font-weight: 800;
          color: #132F59;
          line-height: 55px;
          padding-left: 8px;
        }
        .en_label {
          font-size: 22px;
          color: #656973;
          line-height: 22px;
          padding: 8px 12px;
          font-weight: 200;
        }
      }
      .content_nav {
        background: #fff;
        flex: 1;
        box-sizing: border-box;
        display: grid;
        padding: 33px 0 80px 60px;
        grid-template-columns: 30% auto;
        .description_text {
          display: flex;
          flex-direction: column;
          justify-content: center;
          .title {
            color: #000013;
            font-size: 40px;
            font-weight: 800;
            line-height: 30px;
          }
          .en_title {
            font-size: 30px;
            font-family: 'SourceHanSansLight', sans-serif;
            color: #656973;
            line-height: 22px;
            margin-left: 20px;
            font-weight: 200;
          }
          .public_benefit_content {
            .address {
              font-size: 40px;
              font-weight: 600;
              color: #132F59;
              line-height: 55px;
            }
            .coord {
              font-size: 20px;
              font-weight: 400;
              color: #656973;
              line-height: 20px;
              margin: 14px 0 40px 0;
              display: flex;
              align-items: center;
              img{
                width: 20px;
                height: 20px;
                margin-right: 12px;
              }
            }
            .address_introduce {
              font-size: 18px;
              font-weight: 400;
              width: 426px;
              color: #656973;
              line-height: 27px;
              padding-top: 16px;
            }

          }
        }
        .swipper_box {
          display: grid;
          grid-template-rows: 400px auto;
          .el-carousel--horizontal {
            overflow: hidden;
          }
          .button_nav {
            position: relative;
            // top: -60px;
            .page_text {
              font-size: 18px;
              position: absolute;
              cursor: pointer;
              width: 25px;
              left: 291px;
              top: 20px;
              white-space: nowrap;
            }
            .current_page {
              font-size: 24px;
              color: #5E6070;
            }
            .next_page {
              color: #D8D8D8;
            }
            .left_icon {
              width: 40px;
              height: 40px;
              position: absolute;
              cursor: pointer;
              left: 216px;
              top: 16px;
            }
            .left_icon2 {
              width: 40px;
              height: 40px;
              position: absolute;
              cursor: pointer;
              left: 216px;
              top: 16px;
              transform: rotateY(180deg);
            }
            .right_icon {
              width: 40px;
              height: 40px;
              position: absolute;
              cursor: pointer;
              left: 384px;
              top: 16px;
            }
          }
          .right_icon2 {
            width: 40px;
            height: 40px;
            position: absolute;
            cursor: pointer;
            left: 384px;
            top: 16px;
            transform: rotateY(180deg);
          }
          .next {
            transform: translateX(760px) scale(1) !important;
          }
          .is-in-stage {
            transform: translateX(960px) scale(1);
          }
          .is-active {
            width: 640px;
            transform: translateX(0px) scale(1) !important;
          }
          .swipper_img {
            width: 640px;
            height: 400px;
            border-radius: 10px;
            object-fit: cover;
          }
        }
      }
    }

  }
  .green_energy_expert_nav {
    width: 100%;
    background: #ffffff;
    text-align: center;
    display: flex;
    padding: 184px 353px;
    box-sizing: border-box;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .app_explain {
      height: 120px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .app_explain_bg {
        position: absolute;
        font-size: 150px;
        font-weight: bold;
        color: #FBFBFB;
        line-height: 120px;
      }
      .name {
        font-size: 34px;
        font-family: PingFang-SC-Heavy, PingFang-SC;
        font-weight: 800;
        color: #000013;
        line-height: 42px;
        position: relative;
      }
      .slogan, .description_text {
        font-size: 18px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        width: 1158px;
        font-weight: 500;
        color: #474747;
        line-height: 22px;
        position: relative;
      }
      
      .slogan {
        padding: 8px 0 18px;
      }
    }
    
  }
  .new_box{
    width: 100%;
    .weitu{
      width: 530px;
      position: absolute;
      top: 140px;
      right: 200px;
    }
    .new_title{
      font-size: 50px;
      font-weight: bold;
      color: #132F59;
      display: flex;
      align-items: center;
      img{
        height: 136px;
      }
    }
    .new_slogan{
      color: #656973;
      font-size: 30px;
      margin-top: 30px;
      line-height: 42px;
      font-weight: 200;
      font-family: 'SourceHanSansLight', sans-serif;
    }
    .new_content{
      margin-top: 120px;
      font-size: 24px;
      width: 850px;
      line-height: 40px;
      color: #656973;
    }
  }
  .xxcn{
    height: 700px;
    background: url(https://sys.huwei.xin:7443/huwei-website/imageNew/index/xxcn_bg.png) 0 0 no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 100px 0 0 200px;
    position: relative;
  }
  .lvnp{
    height: 615px;
    background: url(https://sys.huwei.xin:7443/huwei-website/imageNew/index/lvnp_bg.png) 0 0 no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 100px 0 0 200px;
    position: relative;
  }
  .zlzs{
    height: 1080px;
    background: url(https://sys.huwei.xin:7443/huwei-website/imageNew/index/zlzs.png) 0 0 no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 100px 0 0 200px;
    position: relative;
  }
  .hzjd{
    background: #fff;
    box-sizing: border-box;
    padding: 100px 200px;
    position: relative;
    // .new_title{
    //   span{
    //     line-height: 70px;
    //   }
    //   img{
    //     width: 50px;
    //     height: 50px;
    //     margin-left: 20px;
    //   }
    // }
    .cooperation_content {
      width: 1600px;
      overflow: auto;
      display: flex;
      position: relative;
      .cooperation_box {
        
        flex: 1;
        display: flex;
        padding: 100px 0 0 0;
        flex-direction: column;
        grid-gap: 50px;
        .button {
          position: absolute;
          top: 20px;
          right: 86px;
          display: inline-flex;
          justify-content: end;
          padding-right: 0;
          grid-gap: 20px;
          .icon {
            width: 40px;
            height: 40px;
            cursor: pointer;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #3D3F55;
            font-size: 15px;
            border: 1px solid #3D3F55;
            margin-left: 30px;
          }
          .icon:hover{
            background: #1667FF;
            color: #fff;
            border: 1px solid #fff;
          }
        }
        .menu {
          display: flex;
          grid-gap: 62px;
          .item_box {
            width: 463px;
            height: 542px;
            position: relative;
            .img {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
              z-index: 11;
              object-fit: cover;
            }
            .hotel_info{
              width: 463px;
              height: 260px;
              position: absolute;
              left: 0;
              bottom: 0;
              background: linear-gradient( 180deg, rgba(49,164,227,0) 0%, #213C63 100%);
              z-index: 22;
              padding: 148px 0 0 40px;
              box-sizing: border-box;
            }
            .hotel_name {
              font-size: 28px;
              color: #FFFFFF;
              line-height: 34px;
            }
            .address {
              font-size: 20px;
              color: #FFFFFF;
              line-height: 24px;
              padding-top: 10px;
            }
          }
        }
      }
    }
  }
  .lvzj{
    height: 940px;
    background: #fff;
    box-sizing: border-box;
    padding: 100px 0 0 200px;
    position: relative;
    .menu {
      display: grid;
      grid-template-columns: repeat(3,515px);
      margin-top: 100px;
      .item {
        width: 500px;
        height: 247px;
        margin-bottom: 15px;
        padding: 0 40px 40px;
        box-sizing: border-box;
        border: 1px solid #CEDFFF;
        text-align: left;
        .item_title{
          margin-top: 30px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        img {
          width: 64px;
          height: 64px;
        }
        .label {
          font-size: 20px;
          font-weight: 600;
          color: #02031F;
          line-height: 25px;
          position: relative;
          .heng{
            position: absolute;
            left: 0;
            bottom: -10px;
            background-color: rgba(22, 103, 255, 1);
            width: 31px;
            height: 2px;
          }
          .heng2{
            position: absolute;
            left: 31px;
            bottom: -10px;
            width: 11px;
            height: 2px;
            background: #00B386;
          }
        }
        .description {
          font-size: 18px;
          font-weight: 400;
          color: #656973;
          line-height: 26px;
          padding-top: 36px;
          
        }
      }
    }
  }
  .index_icons{
    background: url(https://sys.huwei.xin:7443/huwei-website/imageNew/index/td_bg.png) 0 0 no-repeat;
    background-size: 100% 100%;
    width: 100%;
    box-sizing: border-box;
    height: 235px;
    display: flex;
    align-items: center;
    justify-content: center;
    .icon_li{
      display: flex;
      flex-direction: column;
      width: 280px;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      color: #132F59;
      position: relative;
      img{
        width: 60px;
        height: 60px;
      }
      span{
        margin-top: 30px;
      }
      .bian{
        position: absolute;
        right: 0;
        top: 0;
        width: 1px;
        height: 100%;
        background: #637795;
      }
    }
  }
  
  .public_benefit_column_nav {
    background: url(https://sys.huwei.xin:7443/huwei-website/imageNew/index/yjsb_bg.png) 0 0 no-repeat;
    background-size: 100% 100%;
    height: 640px;
    .content_nav {
      padding: 100px 200px 0;
      box-sizing: border-box;
      .description_text {
        .title {
          color: #000013;
          font-size: 40px;
          font-weight: 800;
          line-height: 30px;
        }
        .en_title {
          font-size: 30px;
          font-family: 'SourceHanSansLight', sans-serif;
          color: #656973;
          line-height: 22px;
          margin-left: 20px;
          font-weight: 200;
        }
      }
      .menu {
        display: grid;
        margin-top: 100px;
        grid-template-columns: repeat(6,1fr);
        grid-gap: 21px 30px;
        .item_boxs {
          width: 232px;
          height: 284px;
          background: #FFFFFF;
          position: relative;
          padding: 20px;
          box-sizing: border-box;
          .heng{
            position: absolute;
            width: 80%;
            height: 2px;
            background: #1667FF;
            bottom: 0;
            left: 0;
          }
          .heng1{
            position: absolute;
            width: 20%;
            height: 2px;
            background: #00B386;
            bottom: 0;
            right: 0;
          }
          .item {
            .label_box {
              .label {
                font-size: 20px;
                color: #02031F;
                line-height: 27px;
                font-weight: bold;
                margin: 28px 0 12px 0;
              }
              .en_label {
                font-size: 16px;
                color: #02031F;
                line-height: 25px;
                font-weight: 200;
                font-family: 'SourceHanSansLight', sans-serif;
              }
            }
          }
          .img_box {
            img {
              width: 192px;
              height: 128px;
            }
          }
        }
      }
    }
  }
  .characteristic_description_nav {
    background: #ffffff;
    padding: 100px 200px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    .menu {
      width: 746px;
      height: 222px;
      padding-bottom: 40px;
      box-sizing: border-box;
      text-align: left;
      position: relative;
      // background: url(../assets/img/imageNew/index/num_bg1.png) 0 0 no-repeat;
      // background-size: 100% 100%;
      margin-bottom: 25px;
      padding: 50px;
      position: relative;
      >img{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
      }
      .label {
        font-size: 30px;
        font-weight: 600;
        color: #02031F;
        line-height: 42px;
        position: relative;
        z-index: 10;
      }
      .description {
        font-size: 18px;
        font-weight: 400;
        color: #656973;
        line-height: 25px;
        padding-top: 30px;
        position: relative;
        z-index: 10;
      }
    }
    .two{
      background: url(https://sys.huwei.xin:7443/huwei-website/imageNew/index/num_bg2.png) 0 0 no-repeat;
      background-size: 100% 100%;
    }
    .three{
      background: url(https://sys.huwei.xin:7443/huwei-website/imageNew/index/num_bg3.png) 0 0 no-repeat;
      background-size: 100% 100%;
    }
    .four{
      background: url(https://sys.huwei.xin:7443/huwei-website/imageNew/index/num_bg4.png) 0 0 no-repeat;
      background-size: 100% 100%;
    }
  }
  .certificate_nav {
    background: url(https://sys.huwei.xin:7443/huwei-website/certificate_bg.png) 0 0 no-repeat;
    background-size: 100% 100%;
    height: 762px;
    padding: 80px 141px 95px;
    box-sizing: border-box;
    .certificate_title {
      .title_bg {
        position: absolute;
        font-size: 137px;
        font-weight: bold;
        color: #fbfbfb8a;
        line-height: 120px;
      }
      .title {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 120px;
        position: relative;
        color: #000013;
        .title_text {
          font-size: 34px;
          font-weight: 800;
          line-height: 36px;
        }
        .slogan {
          font-size: 18px;
          font-weight: 500;
          line-height: 22px;
          padding-top: 10px;
        }
      }
    }
    .certificate_content {
      display: flex;
      justify-content: center;
      padding-top: 80px;
      .certificate_menu {
        display: flex;
        flex-direction: column;
        padding: 0 40px;
        margin-top: 100px;
        .label {
          width: 254px;
          height: 49px;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 1px dashed #555555;
          border-radius: 25px;
          font-size: 22px;
          font-weight: 400;
          color: #545454;
          line-height: 30px;
          margin-top: 80px;
        }
      }
    }
  }
  .cooperation_hotel_nav {
    .app_explain {
      width: 100%;
      background: #ffffff;
      text-align: center;
      display: flex;
      padding: 150px 353px 90px;
      box-sizing: border-box;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .app_explain_bg {
        position: absolute;
        font-size: 150px;
        font-weight: bold;
        color: #FBFBFB;
        line-height: 120px;
      }
      .name {
        font-size: 34px;
        font-family: PingFang-SC-Heavy, PingFang-SC;
        font-weight: 800;
        color: #000013;
        line-height: 42px;
        position: relative;
      }
      .slogan {
        font-size: 18px;
        width: 1158px;
        font-weight: 500;
        color: #474747;
        line-height: 22px;
        padding: 8px 0 18px;
        position: relative;
      }
    }
    
  }
}
</style>
